import CartItem from '../CartItem'
import CartContext from '../../context/CartContext'

import './index.css'

const CartListView = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList, totalAmount} = value
      console.log(totalAmount, 'total')
      return (
        <>
          <ul className="cart-list">
            {cartList.map(eachCartItem => (
              <CartItem key={eachCartItem.id} cartItemDetails={eachCartItem} />
            ))}
          </ul>
          <h1 className="cart-heading">Total Amount = Rs {totalAmount}</h1>
        </>
      )
    }}
  </CartContext.Consumer>
)

export default CartListView
